
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M42.857 26.786h-9.643v-9.643c0-1.183-.96-2.143-2.143-2.143H28.93c-1.184 0-2.143.96-2.143 2.143v9.643h-9.643c-1.183 0-2.143.96-2.143 2.143v2.142c0 1.184.96 2.143 2.143 2.143h9.643v9.643c0 1.183.96 2.143 2.143 2.143h2.142c1.184 0 2.143-.96 2.143-2.143v-9.643h9.643c1.183 0 2.143-.96 2.143-2.143V28.93c0-1.184-.96-2.143-2.143-2.143z"}})])
          )
        }
      }
    